export const NEWS_FEED_MODAL = 'newsFeedModal'
export const SUBJECT = 'subject'
export const ASSIGN = 'assign'
export const TEXT = 'text'
export const REQUIRE_CONFIRMATION = 'requireConfirmation'
export const PIN_A_MESSAGE = 'pinAmessage'
export const CHECKED_ITEMS = 'checkedItems'
export const AUDIENCE_BY = 'audienceBy'
